export default {
	state: () => ({}),
	mutation: {},
	actions: {},
	getters: {},
};



// WEBPACK FOOTER //
// ./src/store/Task/modules/kingkong.js